/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Invite_Codes_Max_Uses_LabelInputs */

const en_admin_invite_codes_max_uses_label = /** @type {(inputs: Admin_Invite_Codes_Max_Uses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Max uses (per code)`)
};

const zh_admin_invite_codes_max_uses_label = /** @type {(inputs: Admin_Invite_Codes_Max_Uses_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最大使用次数(每个码)`)
};

/**
* | output |
* | --- |
* | "Max uses (per code)" |
*
* @param {Admin_Invite_Codes_Max_Uses_LabelInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_invite_codes_max_uses_label = /** @type {((inputs?: Admin_Invite_Codes_Max_Uses_LabelInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Invite_Codes_Max_Uses_LabelInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_invite_codes_max_uses_label(inputs)
	return zh_admin_invite_codes_max_uses_label(inputs)
});
export { admin_invite_codes_max_uses_label as "admin.invite_codes.max_uses_label" }